/** @format */

import {
	AfterViewInit,
	Component,
	ComponentRef,
	computed,
	Inject,
	inject,
	input,
	Input,
	ViewChild
} from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { BreakPointNew } from '@shared/data-access/enums';

import { HmfDrawerComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';

import {
	AppProductReviewState,
	cleanReviewFilters,
	cleanSelectedTag,
	closeProductReviewDrawer,
	ComponentHandlerService,
	ProductReviewDrawerType,
	removeSearchFilter,
	removeSortFilter
} from '@product-reviews/data-access';
import { ReviewQuestionsAndAnswersComponent } from '../review-questions-and-answers/review-questions-and-answers.component';
import { ReviewsDrawerContainerComponent } from '../reviews-drawer-container/reviews-drawer-container.component';
import { TrapFocusDirective } from '../directive/trap-focus/trap-focus.directive';
import { BreakpointsService } from '@shared/data-access/services';

@Component({
	selector: 'product-reviews-review-information-drawer',
	templateUrl: './review-information-drawer.component.html',
	styleUrl: './review-information-drawer.component.scss',
	imports: [
		CommonModule,
		HmfDrawerComponent,
		ReviewQuestionsAndAnswersComponent,
		ReviewsDrawerContainerComponent,
		TrapFocusDirective
	]
})
export class ReviewInformationDrawerComponent implements AfterViewInit {
	private readonly breakpointsService = inject(BreakpointsService);

	@Input() selfReference: ComponentRef<ReviewInformationDrawerComponent> | null = null;
	@Input() reviewDrawerType: ProductReviewDrawerType = ProductReviewDrawerType.NONE;
	@Input() drawerTitle = '';
	@Input() isFirstPanelOpen = true;

	readonly ratingCount = input<number | null>(null);
	readonly ratingValue = input<number | null>(null);

	drawerTypeOptions = ProductReviewDrawerType;

	isMobile = computed(() => this.breakpointsService.breakpoint() <= BreakPointNew.MEDIUM);

	@ViewChild(HmfDrawerComponent, { static: true }) drawerComponent: HmfDrawerComponent;

	constructor(
		private store: Store<AppProductReviewState>,
		private componentHandlerService: ComponentHandlerService,
		@Inject(DOCUMENT) private document: Document
	) {}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.openDrawer();
		}, 0);
	}

	// TODO: Remove this when homefield drawer supports host listeners
	activeKeydownEvent({ key }: KeyboardEvent): void {
		const closeButton = this.document.querySelector(
			'hmf-drawer .reviews-information-modal .hmf-modal-container-close'
		);

		if (key === 'Enter' && closeButton === this.document.activeElement) {
			this.closeDrawer();
		}
	}

	closeDrawer(): void {
		if (this.selfReference) {
			this.clearStore();
			this.deleteComponent();
		}
	}

	private openDrawer(): void {
		this.drawerComponent?.openDrawer();
	}

	private deleteComponent(): void {
		this.componentHandlerService.remove(this.selfReference);
		this.selfReference = null;
	}

	private clearStore(): void {
		this.store.dispatch(closeProductReviewDrawer());
		this.store.dispatch(cleanReviewFilters());
		this.store.dispatch(removeSearchFilter());
		this.store.dispatch(cleanSelectedTag());
		this.store.dispatch(removeSortFilter());
	}
}
